import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import {
  fetchAlert,
  setSelectedAlertID,
  setSelectedCallerID,
} from '@rsos/reduxDataStore';

interface InteragencyState {
  selectedInteragencyChat: string | null;
  pendingInteragencyMessage: string | null;
}

const initialState: InteragencyState = {
  selectedInteragencyChat: null,
  pendingInteragencyMessage: null,
};

const interagencySlice = createSlice({
  name: 'interagency',
  initialState,
  reducers: {
    setSelectedInteragencyChat(state, action: PayloadAction<string | null>) {
      state.selectedInteragencyChat = action.payload;
    },
    setPendingInteragencyMessage(state, action: PayloadAction<string | null>) {
      state.pendingInteragencyMessage = action.payload;
    },
  },
  selectors: {
    selectSelectedInteragencyChat: state => state.selectedInteragencyChat,
    selectPendingInteragencyMessage: state => state.pendingInteragencyMessage,
  },
  extraReducers: builder => {
    builder
      .addCase(
        setSelectedCallerID,
        (state, action: PayloadAction<string | null>) => {
          if (action.payload) state.selectedInteragencyChat = null;
        },
      )
      .addCase(
        setSelectedAlertID,
        (state, action: PayloadAction<string | null>) => {
          if (action.payload) state.selectedInteragencyChat = null;
        },
      )
      .addCase(fetchAlert.fulfilled, (state, action) => {
        if (action.payload?.shouldSetID) state.selectedInteragencyChat = null;
      });
  },
});

const selectors = interagencySlice.selectors;

export const useSelectedInteragencyChat = () =>
  useSelector(selectors.selectSelectedInteragencyChat);

export const usePendingInteragencyMessage = () =>
  useSelector(selectors.selectPendingInteragencyMessage);

export const { setSelectedInteragencyChat, setPendingInteragencyMessage } =
  interagencySlice.actions;

export default interagencySlice.reducer;
